export default __webpack_public_path__ + "3d19faab87d483d2178e039bf5031a02.png";